import { decodeJwt } from "jose";
import { useBearerToken } from "./useBearerToken";

export function useUserTokenInfo() {
  const token = useBearerToken();
  if (!token) {
    return undefined;
  }
  const userInfo = decodeJwt(token);
  const name =
    typeof userInfo.given_name === "string" ? userInfo.given_name : undefined;
  const surname =
    typeof userInfo.family_name === "string" ? userInfo.family_name : undefined;
  const userName =
    typeof userInfo.unique_name === "string" ? userInfo.unique_name : undefined;
  const fullName = name && surname ? `${name} ${surname}` : undefined;
  const nickname =
    typeof userInfo.nickname === "string" ? userInfo.nickname : undefined;
  const givenName =
    typeof userInfo.given_name === "string" ? userInfo.given_name : undefined;
  const familyName =
    typeof userInfo.family_name === "string" ? userInfo.family_name : undefined;
  const phoneNumber =
    typeof userInfo.phone_number === "string"
      ? userInfo.phone_number
      : undefined;
  const email = typeof userInfo.email === "string" ? userInfo.email : undefined;
  return {
    ...userInfo,
    name,
    surname,
    userName,
    fullName,
    nickname,
    givenName,
    familyName,
    phoneNumber,
    email,
  };
}
